import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { LfsaBotonEditarGridComponent } from '../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { SharedModule } from '../../shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { PLMRoutingModule } from './plm-routing.module';
import { QmMatrizMantenimientoComponent } from './views/qm-matriz-mantenimiento/qm-matriz-mantenimiento.component';
import { QmMatrizUploadCsvComponent } from './views/qm-matriz-upload-csv/qm-matriz-upload-csv.component';
import { QmMatrizHistoricoComponent } from './views/qm-matriz-historico/qm-matriz-historico.component';
import { FileUploadModule } from 'primeng/fileupload';

@NgModule({
  declarations: [
    QmMatrizMantenimientoComponent,
    QmMatrizUploadCsvComponent,
    QmMatrizHistoricoComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    AgGridModule.withComponents([LfsaBotonEditarGridComponent]),
    NgSelectModule,
    PLMRoutingModule,
    FileUploadModule,
    NgSelectModule,
  ]
})

export class PlmModule { }